module.exports = __webpack_public_path__ + "app/community/cooperative/cooperative-detail-2dSRr6TR.html";